import { IPersistedQcRun } from './Interfaces';

export interface IBrowserPersistenceState {
    qcRuns: IPersistedQcRun[];
}

export const initialBrowserPersistenceState: IBrowserPersistenceState = {
    qcRuns: [],
};
